import { render, staticRenderFns } from "./hostTest.vue?vue&type=template&id=3f85287d&scoped=true&"
import script from "./hostTest.vue?vue&type=script&lang=js&"
export * from "./hostTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85287d",
  null
  
)

export default component.exports